export type Markets = [
  'agriculture',
  'civil-engineering',
  'construction',
  'flue-gas-treatment',
  'glass',
  'lhoist',
  'non-ferrous',
  'paper',
  'steel',
  'water',
];

type ObjectToArray<T> = {
  [K in keyof T]: T[K];
}[keyof T][];
type PrefixedMarkets = {
  [K in Markets[number]]: `markets-${K}`;
};
export type MarketColors = ObjectToArray<PrefixedMarkets>;

export type Poi = {
  name: string;
  category: Markets[number];
  alt: string;
  width: number;
  height: number;
  top: number;
  left: number;
  subpois: number[];
  pin: {
    top: number;
    left: number;
  };
};

export type Position = {
  x: number;
  y: number;
};

export enum Languages {
  'en' = 'en',
  'en-AS' = 'en',
  'en-GB' = 'en',
  'en-US' = 'en',
  'en-ND' = 'en',
  'es-ES' = 'es',
  'es-BR' = 'es',
  'pt-PT' = 'pt',
  'pt-BR' = 'pt-BR',
  'fr-FR' = 'fr',
  'fr-BX' = 'fr',
  'nl-BX' = 'nl',
  'de-DE' = 'de',
  'pl-PL' = 'pl',
  'cs-CZ' = 'cs',
}
export type LanguageCode = keyof typeof Languages;

export type Regions = ['global', 'asia-pacific', 'north-america', 'latin-america', 'europe'];
export type LanguageSelectorLocaleData = {
  region: Regions[number];
  country?: string;
  language: LanguageCode;
};

export type AnimatedElement = {
  name: string;
  alt: string;
  width: number;
  height: number;
  left: number;
  top: number;
  startingFrame: number;
  endingFrame: number;
  frames: number;
  duration: number;
  engine?: 'webgl' | 'sprite';
  hidden?: boolean;
};

export type ZoneAnimation = AnimatedElement[];

export const carColors = [
  'black',
  'blue',
  'brown',
  'cream',
  'green',
  'orange',
  'pink',
  'red',
  'white',
  'yellow',
] as const;

export type CarColors = (typeof carColors)[number];

export type Area = {
  width: number;
  height: number;
  left: number;
  top: number;
};

export type FirstAnimationFrame<T extends 'bw' | 'rgb'> = `anim-id-${number}-A-first-${T}`;

export type HttpsLink = `https://${string}`;
